import React from 'react';
import '../../../App.css';
import InfoSection from './InfoSection';
import Lines from './Lines';
import Footer from '../../Footer';
import "./Home.css";

function Home() {

  return (
    <>
      <InfoSection />
      <Lines />
      <Footer />
    </>
  );
}

export default Home;